export default __webpack_public_path__ + "static/media/messageSchoolwideLogo.352ac32e.jpeg";